import React from 'react'
import { statusColor } from '../../../../types/statusProject';
import { handlersDeleteRow } from '../helpers/deleteRow';
import SecondaryDetailCard from './SecondaryDetailCard';
import { useTabModal } from '../hooks/useTabModal';
import CardProjectFiche from './CardProjectFiche';
import CardProgressBar from './CardProgressBar';
import CardProyectInfo from './CardProyectInfo';
import { WrapperFiche } from './WrapperFiche';
import CardDetailTime from './CardDetailTime';
import ActionButtons from './ActionButtons';
import CardCalendar from './CardCalendar';
import PrimaryCard from './PrimaryCard';
import DetailGraph from './DetailGraph';
import CardClient from './CardClient';
import CardPause from './CardPause';
import CardAdmin from './CardAdmin';
import CardTeam from './CardTeam';



export const ContainerFiche = ({ project, auth, query, getProjectDetails }) => {
    const { isLoadingModal, openModal } = useTabModal()

    const handleOpenDetailsProject = (type, extraData = {}) => {
        openModal({ type, extraData, project, auth, getProjectDetails });
    };

    const deleteRowByTable = async (type, values = {}) => {
        const isUpdatePage = await handlersDeleteRow[type]({ form: values, extraData: { idSpace: project.clickupSpace } })
        if (!isUpdatePage) return
        await getProjectDetails(project.clickupSpace)
    }

    const { calculatedHours, hasSubstasks } = project;


    return (
        <WrapperFiche loading={isLoadingModal}>
            <section className="w-full h-100  pt-5 pb-10 px-5 bg-[#E6E6E6] overflow-hidden">
                <ActionButtons
                    projectDetails={project}
                    auth={auth}
                    activeModalDetailsProject={handleOpenDetailsProject}
                    isDebugTesting={query.get("debug") ? query.get("debug") === "true" : false}
                    getProjectDetails={getProjectDetails}
                />
                <div className="scroll-project-details w-full h-full overflow-y-scroll grid grid-cols-1 gap-4 md:grid-cols-8 xl:grid-cols-10  ">
                    <div className="col-span-full flex items-center gap-4 overflow-hidden h-[45px]">
                        <div className="flex-grow">
                            <h2 className="text-[20px] font-bold truncate">
                                {project.name}
                                <span style={{ color: statusColor[project.status] || "black" }}>({project.status})</span>
                                {hasSubstasks && <span className='text-red-500'> [Corregir subtareas]</span>}
                            </h2>
                        </div>
                        <div className="flex-grow-0 h-[2px] bg-[#CDCDCD] w-full"></div>
                    </div>
                    <div className="flex flex-col gap-4 md:col-span-4 xl:col-span-6">
                        <div className="grid grid-cols-2 gap-2 ">
                            <PrimaryCard percentage={project.percentage} subtract={project.difference} />
                        </div>
                        <div className="grid grid-cols-2 gap-4 ">
                            <SecondaryDetailCard
                                hrsTotal={project.totalGlobalSpentTime}
                                hrsTotalByClickup={project.totalSpentTime}
                                hrsTotalExtraResource={project.totalExtraResources}
                                hrsTotalExtraTime={project.totalExtraTime}
                                budgetHrsDevelopment={calculatedHours?.development.total}
                                budgetHrsPlanning={calculatedHours?.planning}
                                budgetHrsTesting={calculatedHours?.development?.testing}
                                budgetHrsTotal={calculatedHours?.total}
                            />
                        </div>
                    </div>
                    <div className="md:col-span-4 xl:col-span-4">
                        <DetailGraph size={project.size} graphArea={project.graphArea} />
                    </div>
                    <div className="md:col-span-full xl:col-span-5">
                        <CardProgressBar
                            isAdmin={auth.isAdmin}
                            isSuperAdmin={auth.isSuperAdmin}
                            spaceId={project.clickupSpace}
                            tableIndication={project.tableIndication}
                            activeModalDetailsProject={handleOpenDetailsProject}
                        />
                    </div>
                    <div className="order-3 md:order-2 md:col-span-4 xl:col-span-5 ">
                        <CardProjectFiche title="Testing">
                            <CardDetailTime lists={project.testingLists?.Lists} />
                        </CardProjectFiche>
                    </div>
                    <div className="order-3 md:order-1 xl:order-3 md:col-span-4 md:row-span-3 xl:col-span-5 xl:row-span-2">
                        <CardProyectInfo
                            isAdmin={auth.isAdmin}
                            isSuperAdmin={auth.isSuperAdmin}
                            activeModalDetailsProject={handleOpenDetailsProject}
                            projectDetails={project}
                        />
                    </div>
                    <div className="order-3 md:col-span-4 xl:col-span-5">
                        <CardClient
                            isSuperAdmin={auth.isSuperAdmin}
                            isAdmin={auth.isAdmin}
                            client={project.client}
                            activeModalDetailsProject={handleOpenDetailsProject}
                        />
                    </div>
                    <div className="order-3 md:col-span-4 xl:col-span-5">
                        <CardTeam
                            isSuperAdmin={auth.isSuperAdmin}
                            isAdmin={auth.isAdmin}
                            team={project.team}
                            activeModalDetailsProject={handleOpenDetailsProject}
                        />
                    </div>
                    <div className="order-5 md:order-4 md:col-span-4 xl:col-span-5">
                        <CardPause pauses={project.pauses} />
                    </div>
                    <div className="order-5 md:order-3 md:col-span-4 xl:col-span-5">
                        <CardCalendar
                            dates={project.dates}
                            isAdmin={auth.isAdmin}
                            isSuperAdmin={auth.isSuperAdmin}
                            activeModalDetailsProject={handleOpenDetailsProject}
                            pauses={project.pauses}
                        />
                    </div>
                    <CardAdmin
                        deleteRow={deleteRowByTable}
                        activeModalDetailsProject={handleOpenDetailsProject}
                        auth={auth}
                        projectDetails={project}
                    />
                </div>
            </section>
        </WrapperFiche>
    )
}
